import { useMemo } from 'react';
import { useTagsQuery } from './useTagsQuery';

export const useTagsSuggestion = (alreadyPresent?: string[]) => {
  const { data } = useTagsQuery();

  const tagsToSuggest = useMemo(() => {
    const allTags = data?.map((tag) => tag.name) ?? [];
    const tags = !alreadyPresent ? allTags : allTags.filter((b) => alreadyPresent.every((a) => a !== b));
    return Array.from(new Set(tags));
  }, [data, alreadyPresent]);

  return tagsToSuggest;
};
